import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TeamLogo from "../../components/TeamLogo";
import { getActiveNbaFranchises } from "../../utils/nbaFranchises";
import { colors } from "../../theme";
import { homeCardHover } from "../../components/home/homeStyles";

const NbaTeams = () => {
  const navigate = useNavigate();
  const franchises = getActiveNbaFranchises();

  return (
    <Box sx={{ py: { xs: 1, sm: 2 }, maxWidth: 1200, mx: "auto" }}>
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.2 }}>
        Basketball
      </Typography>
      <Typography variant="h4" component="h1" fontWeight={700} sx={{ mt: 0.5, mb: 1 }}>
        NBA Teams
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 560, mb: 3 }}>
        Current franchises from Basketball-Reference — tap one to see players who
        suited up for that club, including historical names.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(3, 1fr)",
            md: "repeat(5, 1fr)",
          },
          gap: 1.5,
        }}
      >
        {franchises.map((franchise) => (
          <ButtonBase
            key={franchise.id}
            onClick={() => navigate(`/app/nba/teams/${franchise.id}`)}
            sx={{
              p: 2,
              borderRadius: 1.5,
              border: `1px solid ${colors.border}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              textAlign: "center",
              ...homeCardHover,
            }}
          >
            <TeamLogo
              sport="nba"
              franchiseId={franchise.id}
              teamName={franchise.name}
              size={56}
            />
            <Typography variant="body2" fontWeight={700} sx={{ lineHeight: 1.25 }}>
              {franchise.name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {franchise.years} seasons
              {franchise.titles
                ? ` · ${franchise.titles} title${franchise.titles === 1 ? "" : "s"}`
                : ""}
            </Typography>
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
};

export default NbaTeams;
